import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getPrincipalSliceContent = createAsyncThunk('/principal/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getPrincipal`);   
    return response;
})

export const principalSlice = createSlice({
    name: 'principal',
    initialState: {
        isLoading: false,
        principal : []
    },
    reducers: {
    },
    extraReducers: {
		[getPrincipalSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getPrincipalSliceContent.fulfilled]: (state, action) => {
			state.principal = action.payload.data
			state.isLoading = false
		},
		[getPrincipalSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default principalSlice.reducer